module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title-1":"Разрешён въезд на разгрузку","no-data-1":"В этом списке появятся водители, которые получили разрешение на разгрузку","title-2":"Ожидают разрешение на разгрузку","no-data-2":"В этом списке появятся водители, которые ожидают разрешение"}}')
  delete Component.options._Ctor
}
